import React, { useState, useEffect } from 'react';
import { Card, Button, Typography, Space } from 'antd';
import api from '../services/api';

const { Title, Text } = Typography;

const TestPage: React.FC = () => {
  const [testResult, setTestResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const testAPI = async () => {
    setLoading(true);
    try {
      // 测试基础API
      const response = await api.get('/tickets/test');
      setTestResult(`✅ API测试成功: ${JSON.stringify(response.data)}`);
    } catch (error: any) {
      setTestResult(`❌ API测试失败: ${error.message}`);
      console.error('API测试错误:', error);
    }
    setLoading(false);
  };

  const testTicketsList = async () => {
    setLoading(true);
    try {
      // 测试工单列表
      const response = await api.get('/tickets?limit=5');
      setTestResult(`✅ 工单列表测试成功: ${JSON.stringify(response.data)}`);
    } catch (error: any) {
      setTestResult(`❌ 工单列表测试失败: ${error.message}`);
      console.error('工单列表错误:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    // 自动测试环境
    const userAgent = navigator.userAgent;
    const isWechat = userAgent.includes('micromessenger') || userAgent.includes('wxwork');
    setTestResult(`环境检测: ${isWechat ? '企微环境' : '普通浏览器'}\nUser-Agent: ${userAgent}`);
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <Card>
        <Title level={3}>API测试页面</Title>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button onClick={testAPI} loading={loading}>
            测试基础API
          </Button>
          <Button onClick={testTicketsList} loading={loading}>
            测试工单列表
          </Button>
          <Card size="small">
            <Text>
              <pre style={{ whiteSpace: 'pre-wrap' }}>{testResult}</pre>
            </Text>
          </Card>
        </Space>
      </Card>
    </div>
  );
};

export default TestPage;

